import { Button, Icon } from '../../../atoms'
import React from 'react'
import { connect } from 'react-redux'
import { FsCore } from 'types/fs-core'
import Image from '../../imgix-img'
import classNames from 'classnames'
import dayjs from '../../../utils/date'
import { formatThousands } from '../../../utils/formatter'

const cotInfo = {
  copy: {
    Approved: {
      title: 'We’re pleased to confirm that Capital on Tap have approved your application.',
      body: `<div>Great news! Now you’ve been approved, there’s only a few steps left to set up your account and add a password. When this has been completed, you’ll be able to select your card.<br/><br/>Need help? If you have any questions or would like to discuss your application with Capital on Tap, follow the below link to their reach phone or chat support.<br/><a href="https://www.capitalontap.com/en/company/contact-us/">Contact Support</a></div>`,
    },
    Pending: {
      title: 'We’ve sent your application to Capital on Tap',
      body: '<div>Thank you for applying for a business credit card. Capital on Tap is now processing your request and will be in touch soon to let you know the outcome.<br/><br/>Need help? If you have any questions or would like to discuss your application with Capital on Tap, follow the below link to their reach phone or chat support.<br/><a href="https://www.capitalontap.com/en/company/contact-us/">Contact Support</a></div>',
    },
    Duplicate: {
      title: 'It looks like you’ve already applied',
      body: '<div>Our records show that you’ve already submitted an application. If you believe this is an error, are awaiting confirmation, or need more information, Capital on Tap can help.<br/><br/>Follow the below link to their reach phone or chat support.<br/><a href="https://www.capitalontap.com/en/company/contact-us/">Contact Support</a></div>',
    },
    Declined: {
      title: 'Unfortunately, you’re not eligible for a credit card with Capital on Tap.',
      body: "<div>We haven’t been able to find a credit card that’s right for your business. This could be because your credit score is limited or too low.<br/><br/>To improve your chances of getting a credit card, take a look at your business credit score and find out what's impacting it. You can also explore our alternative products below.</div>",
    },
  },
}

const CaponTapResults = ({ application }) => {
  const declined = application.status === 'Declined'
  return (
    <div
      className={classNames('ResultsCard', {
        'ResultsCard--CoTDecline': application.status === 'Declined',
      })}
    >
      <div className='ResultsCard__title'>
        {!declined && <Icon glyph='tick-circle-bg' size={48} desktopSize={64} fill='#924a8b' />}
        <h2>{cotInfo.copy[application.status]?.title}</h2>
      </div>

      <div className='ResultsCard__details'>
        {application.status === 'Approved' && (
          <div className='ResultsCard__details__success'>
            {application.approvalAmount && (
              <div>
                <strong>Limit</strong>: £{formatThousands(application.approvalAmount)}
              </div>
            )}
            {application.decisionDate && (
              <div>
                <strong>Date</strong>: {dayjs(application.decisionDate).format('DD/MM/YYYY')}
              </div>
            )}
          </div>
        )}
        <div
          className='ResultsCard__details__body--CoT'
          dangerouslySetInnerHTML={{ __html: cotInfo.copy[application.status]?.body }}
        />
      </div>
      <div className='ResultsCard__details__footer'>
        {!declined && application.link && (
          <div className='ResultsCard__cta'>
            <Button variant='primary' size='md' href={application.link} openInNewTab>
              Create your account
            </Button>
          </div>
        )}
        {!declined && (
          <Image
            src={
              'https://img.money.co.uk/s3/uswitch-assets-eu/amp/images/provider/logos/Capital_on_Tap_logo.png'
            }
            critical={false}
            alt={'capital on tap Logo'}
            className='capontapLogo'
          />
        )}
      </div>
      <div
        className={classNames('ResultsCard__privacydetails', {
          'ResultsCard__privacydetails--fullWidth': application.status !== 'Approved',
        })}
      >
        Full details of how Capital on Tap use your data and the lawful basis for its processing can
        be viewed in their{' '}
        <a href='https://www.capitalontap.com/en/legal/privacy-policy/'>privacy policy</a>
      </div>
    </div>
  )
}

export default connect((state: FsCore.State, props: any) => {
  return {
    ...props,
    application: state.components.cotResult,
  }
})(CaponTapResults)
